import React from 'react';

const toc = [
  { id: 'install', label: 'install' },
  { id: 'hello', label: 'hello world' },
  { id: 'build', label: 'compile & run' },
  { id: 'next', label: 'next steps' },
];

const code = {
  hello: `extern "C" function putchar(byte[4] c) -> byte[4]

byte[8] greet = function() {
  putchar(72);  // H
  putchar(105); // i
  putchar(10);  // newline
  return 0;
};
greet();`,
};

function scrollTo(id) {
  const el = document.getElementById('q-' + id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function QuickStart() {
  return (
    <div className="doc-layout">
      <nav className="doc-sidebar">
        <div className="section">quickstart</div>
        {toc.map(s => (
          <a key={s.id} href={'#q-' + s.id} onClick={e => { e.preventDefault(); scrollTo(s.id); }}>
            {s.label}
          </a>
        ))}
      </nav>
      <div className="doc-content">
        <h2>quickstart</h2>

        <h3 id="q-install">1. install</h3>
        <p>
          download the compiler for your platform from the homepage,
          or clone from{' '}
          <a href="https://github.com/Alex000291/celestc" target="_blank" rel="noreferrer">github</a>.
          place the <code>celestc</code> binary somewhere in your <code>PATH</code>.
        </p>

        <h3 id="q-hello">2. hello world</h3>
        <p>create a file named <code>hello.celest</code>:</p>
        <pre>{code.hello}</pre>

        <h3 id="q-build">3. compile &amp; run</h3>
        <pre>celestc hello.celest -o hello
./hello</pre>
        <p>the program should print "Hi" and exit.</p>

        <h3 id="q-next">4. next steps</h3>
        <p>
          explore the <code>examples/</code> directory in the repository for byte values,
          control flow, closures, objects, threads, and all 49 standard library modules.
          see the <a href="#/api">api reference</a> and{' '}
          <a href="#/stdlib">standard library</a> for full documentation.
        </p>
      </div>
    </div>
  );
}